<template>
  <div class="full-width-image" ref="imageContainer">
    <!-- SVG decorativo animado -->
    <svg
      ref="waveSvg"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1440 320"
      class="animated-wave"
    >
      <!-- Definición del degradado -->
      <defs>
        <linearGradient id="waveGradient" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%"  stop-color="#FFFF"/>
          <stop offset="100%" stop-color="#FFF"/>
        </linearGradient>
      </defs>

      <!-- 1. Línea animada (solo trazo) -->
      <path
        ref="wavePathStroke"
        class="wave-path-stroke"
        d="M0,256L80,240C160,224,320,192,480,186.7C640,181,800,203,960,208C1120,213,1280,203,1360,197.3L1440,192L1440,0L1360,0C1280,0,1120,0,960,0C800,0,640,0,480,0C320,0,160,0,80,0L0,0Z"
      />

      <!-- 2. Relleno con degradado -->
      <path
        ref="wavePathFill"
        class="wave-path-fill"
        fill="url(#waveGradient)"
        d="M0,256L80,240C160,224,320,192,480,186.7C640,181,800,203,960,208C1120,213,1280,203,1360,197.3L1440,192L1440,0L1360,0C1280,0,1120,0,960,0C800,0,640,0,480,0C320,0,160,0,80,0L0,0Z"
      />
    </svg>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { gsap } from 'gsap';

export default {
  name: 'FullWidthImage',
  setup() {
    const waveSvg = ref(null);
    const wavePathStroke = ref(null);
    const wavePathFill = ref(null);
    const imageContainer = ref(null);

    const animateIn = () => {
      const pathLength = wavePathStroke.value.getTotalLength();
      wavePathStroke.value.style.strokeDasharray = pathLength;
      wavePathStroke.value.style.strokeDashoffset = pathLength;

      gsap.timeline()
        .fromTo(imageContainer.value,
          { opacity: 0, y: 100 },
          { opacity: 1, y: 0, duration: 1.2, ease: 'power3.out' })
        .fromTo(waveSvg.value,
          { opacity: 0, y: 100 },
          { opacity: 1, y: 0, duration: 1.3, ease: 'power2.out' },
          '-=0.8')
        .to(wavePathStroke.value,
          { strokeDashoffset: 0, duration: 2, ease: 'power2.inOut' },
          '-=1')
        .to(wavePathFill.value,
          { opacity: 1, duration: 1.2, ease: 'power1.out' },
          '-=0.8');
    };

    onMounted(() => {
      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            animateIn();
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.3 });

      if (imageContainer.value) observer.observe(imageContainer.value);
    });

    return { waveSvg, wavePathStroke, wavePathFill, imageContainer };
  }
};
</script>

<style scoped>
.full-width-image {
  width: 100%;
  position: relative;
  overflow: hidden;
  opacity: 0;
  margin-top:-20px;
  transform: translateY(100px);
}

.animated-wave {
  width: 100%;
  height: auto;
  pointer-events: none;
  opacity: 0;
  transform: translateY(100px);
}

.wave-path-stroke {
  fill: none;
  stroke: #ffffff;
  stroke-width: 3;
}

.wave-path-fill {
  opacity: 0; /* Se animará a 1 en GSAP */
}
</style>
